<template lang="html">
	<div class="omapi-plugin-header">
		<div class="omapi-plugin-banner" id="omwp-plugin-banner">
			<div class="omapi-plugin-banner__wrapper">
				<div class="omapi-plugin-banner__logo">
					<img src="../../assets/images/logo-om.svg" alt="OptinMonster Logo">
					<span class="omapi-plugin-banner__page">{{ bannerTitle }}</span>
					<span v-if="betaVersion">&nbsp;&mdash;&nbsp;<strong>Beta Version: {{ betaVersion }}</strong></span>
				</div>
				<ul class="omapi-plugin-banner__icons">
					<li>
						<a class="omapi-plugin-banner__icon omapi-help help-white" target="_blank" rel="noopener" :href="$urls.docs('', 'BannerHelpButton')"></a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script lang="js">
import { mapState, mapGetters } from 'vuex'
import { getAppData } from '@/utils'

export default  {
	mounted () {
		// We only need to fetch notifications here if it isn't already going to happen in the fetchMe route.
		if (this.shouldFetchUser || !this.connected) {
			this.$store.dispatch('notifications/fetch')
		}
	},
	beforeDestroy () {
	},
	computed : {
		...mapGetters([ 'shouldFetchUser', 'connected' ]),
		...mapState([ 'bannerTitle' ]),
		betaVersion () {
			return getAppData('betaVersion')
		},
	},
}

</script>
